export const VERIFICATIONS_TARGETS = {
  CHECKOUT: 'checkout'
};

export const VERIFICATIONS_DEFAULT_STATE = {
  [VERIFICATIONS_TARGETS.CHECKOUT]: null
};
